import { IconName } from 'web-common/src/shared/design-system/components/Icon';

export const MEAL_PLAN_VALUE_PROPS: { copy: string; iconName: IconName }[] = [
  {
    copy: 'FREE DELIVERY',
    iconName: 'main',
  },
  {
    copy: 'PREFERRED PRICING',
    iconName: 'promo',
  },
  {
    copy: 'ACCESS TO TOP-RATED SHEFS',
    iconName: 'starEmpty',
  },
  {
    copy: 'CURATED FOR YOUR HOUSEHOLD',
    iconName: 'homemade',
  },
];
